export default {
  title: 'Tulostettu kuitti',
  form: {
    is_service_fee_hidden_on_receipt: {
      label: 'Piilota palvelumaksu kuitista',
    },
    is_price_section_hidden_on_receipt: {
      label: 'Piilota hintaosio kuitista',
    },
    is_modifier_group_hidden_on_receipt: {
      label: 'Piilota muokkausryhmien nimet kuitista',
    },
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    changes_got_saved: 'Muutokset tallennettiin',
  },
};
